import { mapGetters } from 'vuex';
export default {
  data () {
    return {
    }
  },
  computed:{
    ...mapGetters({ 
        currentCompany: "main/getCurrentCompany",
    }),
  },
  methods: {
    prepareCostForUpload (cost) {
      var image = cost.image;
      cost = JSON.parse(JSON.stringify(cost));    // DEEP CLONE
      if(!cost.customer){
          cost.customer = "";
          cost.project = "";
      }
      if(!cost.cost_type){
          // delete cost.cost_type;
          cost.cost_type = "";
      }
      if(!cost.image){
          delete cost.image;
      }else{
          cost.image = image;
      }
      if(!cost.project){
          cost.project = "";
      }
      if(!cost.supplier){
          cost.supplier = "";
      }
      if(!cost.retention_tax_percentage){
          delete cost.retention_tax_percentage;
      }
      if(!cost.retention_tax_amount){
          delete cost.retention_tax_amount;
      }
      var cost_lines = cost.cost_lines;
      if (this.currentCompany.country === 'ES'){
          if(!cost.retention_tax_amount){
              cost.retention_tax_amount = 0;
          }
          var totalAmount = 0;
          if(cost.subtotal_amount) {
              totalAmount += parseFloat(cost.subtotal_amount);
          }
          if(cost.retention_tax_amount) {
              totalAmount += parseFloat(cost.retention_tax_amount);
          }
          for (var i in cost_lines){
              if (cost_lines[i].amount) {
                  totalAmount += parseFloat(cost_lines[i].amount);
              }
          }
          cost.amount  = Math.round(totalAmount*100)/100;
      }
      cost.cost_lines = [];
      for (var a_line in cost_lines) {
          if (cost_lines[a_line].amount) {
              cost.cost_lines.push(cost_lines[a_line]);
          }
      }
      return cost;
  },
  }
}